import { Alert } from "services/Alert";

import { ALERT_DISPLAY_DURATION } from "const";

Alert.config({ duration: ALERT_DISPLAY_DURATION });
